import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../Style.css";
import PartnerlistWithPayout from "./PartnerlistWithPayout";
import { Button, Checkbox, Radio, Badge, Segmented, message } from "antd";
import LanlistWithPayout from "./LanlistWithPayout";
import { use } from "react";
import { payoutDataWithPartner } from "../helper/payoutdatasample";
import { connect } from "react-redux";
import Logout from "../../../containers/Pages/Login/Logout";
import { useNavigate, useParams } from "react-router-dom";
import { payoutApprovalStagesSuccess } from "../../../redux/PayoutApprovalStages/action";
import { payoutPartnerDataSearch, payoutPartnerDataSuccess } from "../../../redux/PayoutPartnerData/action";
import useSession from "../../CustomLogout/useSession";
import { CloseOutlined, LeftCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { debounce, set } from "lodash";


const PartnerListDetails = (props) => {
  const [landatasource, setLanDatasource] = useState([]);
  const [searchlandatasource, setSearchLanDatasource] = useState([]);
  const [payoutStagesData, setPayoutStagesData] = useState([]);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [makerAction, setMakerAction] = useState(false);
  const [makerPartnerAction, setMakerPartnerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [utrAction, setUtrAction] = useState(false);
  const [radiostate, setRadioState] = useState("All");
  const [currentStage, setCurrentStage] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({ Check: [] });
  const [payoutPartnerData, setPayoutPartnerData] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const { monthlyReportId } = useParams();
  const handleSessionExpired = useSession();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  // const [navItem, setNavItem] = useState([]);

  useEffect(() => {
    handleRadioChange(radiostate, payoutPartnerData.content);

  }, [monthlyReportId, radiostate]);


  useEffect(() => {
    fetchPayoutStagesData();
  }, [monthlyReportId, props.payoutApprovalStagesSuccess]);



  const fetchPayoutStagesData = async () => {
    setDownloading(true);
    // Simulating an API call to fetch payout stages data 
    try {
      const payoutStagesResponse = props.payoutApprovalStagesSuccess({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
      })

      const payoutStagesData = await payoutStagesResponse || [];
      const errorCode = payoutStagesData?.response?.data?.error?.errorCode || payoutStagesData.errorCode;
      const errorMessage = payoutStagesData?.response?.data?.error?.errorMessage || payoutStagesData.errorMessage;
      if (errorCode === "403" && (payoutStagesData?.data?.error?.logoutStatus || payoutStagesData?.response?.data?.error?.logoutStatus)) {

        console.error("Logout status detected, redirecting to login page.");

        handleSessionExpired();
        return;
      }

      setPayoutStagesData(payoutStagesData);
    } catch (error) {
      console.error("Error fetching payout stages data:", error);
    } finally {
      setDownloading(false);
    }

  };


  const fetchPayoutPartnerData = async () => {
    try {
      const payoutPartnerResponse = await props.payoutPartnerDataSuccess({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
        approvalStageId: 1, // Assuming 1 is the default approval stage ID  
        page: 0,
        record: 5, // Assuming 10 records per page
      });
      const payoutPartnerData = payoutPartnerResponse || [];
      const errorCode = payoutPartnerData?.response?.data?.error?.errorCode || payoutPartnerData.errorCode;
      const errorMessage = payoutPartnerData?.response?.data?.error?.errorMessage || payoutPartnerData.errorMessage;
      if (errorCode === "403" && (payoutPartnerData?.data?.error?.logoutStatus || payoutPartnerData?.response?.data?.error?.logoutStatus)) {
        // Handle logout status       
        console.error("Logout status detected, redirecting to login page.");
        handleSessionExpired();
        return;
      }
      setPayoutPartnerData(payoutPartnerData);
      // setLanDatasource(payoutPartnerData);
    } catch (error) {
      console.error("Error fetching payout partner data:", error);
    }
  };



  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const handleStageMap = {
    1: "PendingwithCETMaker",
    2: "PendingwithCETChecker",
    3: "PendingwithCPChecker",
    4: "CpApproved",
    5: "PendingwithPartner",
    6: "PartnerQuery",
    7: "InvoiceUploaded",
    8: "CETApprovalPendingonInvoice",
    9: "CpapprovalpendingonInvoice",
    10: "CpApprovedInvoice",
    11: "Processed",
  }




  const sortedStages = (payoutStagesData || []).slice().sort((a, b) => {
    if (a.id === 0) return -1;
    if (b.id === 0) return 1;
    return 0;
  });

  const options = sortedStages.map((stage) => ({
    label: (
      <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {stage.name}
        <Badge
          shape="circle"
          count={stage.partnerCount}
          overflowCount={99999}
          showZero
          style={{ position: "absolute", top: -38, right: -27, zIndex: 1 }}
        />
      </div>
    ),
    value: handleStageMap[stage.id] || stage.name,
  }));



  const handleCheckboxChange = (e, column, rowId) => {
    const isChecked = e.target.checked;
    setSelectedCheckboxes((prevState) => {
      const newState = { ...prevState };
      if (isChecked) {
        newState[column] = [...newState[column], rowId];
      } else {
        newState[column] = newState[column].filter((item) => item !== rowId);
      }
      return newState;
    });
  };

  const options1 = [
    { label: "As of Month", value: "AsofMonth" },
    { label: "YTD", value: "YTD" },
  ];



  const handlePageChange = async (page, pageSize, approvalStageId) => {
    // Call the API with the new page and pageSize
    const payoutPartnerResponse = await props.payoutPartnerDataSuccess({
      accessToken: props.accessToken,
      reportId: monthlyReportId,
      approvalStageId: approvalStageId,
      page: page - 1, // API is usually 0-indexed
      record: pageSize,
    });
    const res = payoutPartnerResponse;
    setLanDatasource(res.content || []);
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
      total: res?.totalElements,
    }));
  };


  const fetchPaginatedData = async (approvalStageId, radioStateValue) => {
    setDownloading(true);
    try {
      let current = pagination.current || 1;
      let pageSize = pagination.pageSize || 10;
      const response = await props.payoutPartnerDataSuccess({
        accessToken: props.accessToken,
        reportId: monthlyReportId,
        approvalStageId,
        page: current - 1,
        record: pageSize,
      });
      const data = response.content || [];



      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response?.totalElements,
        totalPages: response?.totalPages || 0,
      }));

      setLanDatasource(data);

      setMakerAction(approvalStageId === 1 ? approvalStageId === 1 || radioStateValue === "PendingwithCETMaker" : false);
      setMakerPartnerAction(approvalStageId === 6 ? approvalStageId === 6 || radioStateValue === "PartnerQuery" : approvalStageId === 7 ? approvalStageId === 7 || radioStateValue === "InvoiceUploaded" : approvalStageId === 10 ? approvalStageId === 10 || radioStateValue === "CpApprovedInvoice" : false)
      setCheckerAction(false);
      setUtrAction(radioStateValue === "ApprovedInvoices");
      setSelectedCheckboxes({ Check: [] });
      setRadioState(radioStateValue);
      setCurrentStage(approvalStageId);
      return data;
    } catch (error) {
      console.error("Error fetching paginated data:", error);
    } finally {
      setDownloading(false);
    }

  };



  const handleRadioChange = async (value, data = payoutDataWithPartner) => {



    switch (value) {
      case "All":

        fetchPaginatedData(0, "All");
        break;

      case "PendingwithCETMaker":

        fetchPaginatedData(1, "PendingwithCETMaker");
        break;

      case "PendingwithCETChecker":

        fetchPaginatedData(2, "PendingwithCETChecker");
        break;

      case "PendingwithCPChecker":

        fetchPaginatedData(3, "PendingwithCPChecker");
        break;

      case "CpApproved":

        fetchPaginatedData(4, "CpApproved");
        break;

      case "PendingwithPartner":

        fetchPaginatedData(5, "PendingwithPartner");
        break;

      case "PartnerQuery":

        fetchPaginatedData(6, "PartnerQuery");
        break;

      case "InvoiceUploaded":

        fetchPaginatedData(7, "InvoiceUploaded");
        break;

      case "CETApprovalPendingonInvoice":

        fetchPaginatedData(8, "CETApprovalPendingonInvoice");
        break;

      case "CpapprovalpendingonInvoice":

        fetchPaginatedData(9, "CpapprovalpendingonInvoice");
        break;

      case "CpApprovedInvoice":

        fetchPaginatedData(10, "CpApprovedInvoice");
        break;

      case "Processed":

        fetchPaginatedData(11, "Processed");
        break;

      case "AsofMonth":
        break;

      case "YTD":
        break;

      default:
        setMakerAction(false);
        setCheckerAction(false);
        setUtrAction(false);
        setCurrentStage(null);
        break;
    }
  };

  const clearSearch = async () => {
    setSearchTextTable("");
    setPagination((prev) => ({
      ...prev,
      current: 1, // Reset to first page on search
      pageSize: 10, // Reset page size if needed
    }));
    message.info("clearSearch, showing all data.");
    await fetchPaginatedData(currentStage, radiostate);
    // setLanDatasource(landatasource);
  };



  const debouncedSearch = useMemo(() =>
    debounce(async (value) => {
      const searchValue = String(value || "").trim().toLowerCase();

      if (!searchValue) {
        // Clear search - show all data
        // message.info("Search cleared, showing all data.");
        setPagination(prev => ({
          ...prev,
          current: 1,
          pageSize: 10,
        }));
        await fetchPaginatedData(currentStage, radiostate);
        return;
      }

      try {
        // // Show loading state
        // setLoading?.(true);

        const response = await props.payoutPartnersearch({
          accessToken: props.accessToken,
          reportId: monthlyReportId,
          approvalStageId: currentStage,
          partner_name: searchValue,
        });

        const searchData = response || [];

        if (searchData && searchData.message) {
          if (searchData && searchData.response.data.data.errorMessage) {
            message.error(searchData.response.data.data.errorMessage);
          } else {
            message.error(searchData.message);
          }

          setSearchLanDatasource([]);
          setLanDatasource([]);
        } else {
          setSearchLanDatasource(searchData || []);
          setLanDatasource(searchData || []);
        }




        setPagination(prev => ({
          ...prev,
          current: 1,
          total: searchData.length,
          pageSize: searchData.length > 0 ? searchData.length : 10,
        }));

        // message.info(`Found ${searchData.length} results`);

      } catch (error) {
        console.error("Search error:", error);
        message.error("Search failed. Please try again.");



      } finally {
        // setLoading?.(false);
      }
    }, 300),
    [props.accessToken, monthlyReportId, currentStage, radiostate]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };


  return (
    <div className="dashboardPayout" style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
              type="default"
              style={{
                margin: "0",
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '2px', // space between icon and text
                padding: '0 8px',
                color: '#00b1b1',
              }}
              onClick={() => navigate(-1)}
            >
              <LeftCircleOutlined />
              <span>Back</span>
            </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}

                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ display: "flex" }}>
          <Col lg={4} xs={4} md={4} sm={4}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              <div>
                {/* <Button
                  className="ant-btn ant-btn-default"
                  type="primary"
                  style={{ marginLeft: 5, width: 200, backgroundColor: '#1b8593', color: '#fff', fontSize: '0.9rem', padding: 10, borderRadius: '5px', border: 'none' }}
                >
                  Advance Search
                </Button> */}
              </div>
            </Col>
          </Col>

        </div>
      </Row>


      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <div className="buckets-container" style={{ display: "flex", width: "100%", marginTop: 10 }} >

            <Col md={9} className="radio-group-container" style={{ width: "100%" }}>
              <Radio.Group
                block
                options={options}
                defaultValue="All"
                onChange={(e) => {
                  handleRadioChange(e.target.value);
                }}
                optionType="button"
                buttonStyle="solid"
                buttonCheckedBg="#1b8593"
              />
            </Col>
            <Col md={3} style={{
              width: "20%",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end", marginLeft: "10%"
            }}>
              {makerAction
                ? [
                  // <>
                  //   <Button
                  //     className="ant-btn ant-btn-default "
                  //     style={{

                  //       padding: 10,
                  //       backgroundColor: "#1b8593",
                  //       color: "#fff",
                  //       fontSize: "0.8rem",
                  //       marginTop: "20px",
                  //       borderRadius: "5px",
                  //       width: 80,
                  //       border: 'none'
                  //     }}
                  //   >
                  //     Submit
                  //   </Button>
                  // </>,
                ]
                : []}
            </Col>
          </div>
        </Col>
      </Row>

      <Row style={{ display: "flex", marginTop: 20 }}>
        <Col
          md={9}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
        ></Col>
        <Col
          md={3}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
        >
          <Input
            //  disabled={!searchlandatasource.length}
            className="search-input"
            allowClear
            placeholder="Search..."
            suffix={<SearchOutlined />}
            // prefix={
            //   searchTextTable && (
            //     <CloseOutlined
            //       onClick={clearSearch}
            //       style={{ cursor: "pointer" }}
            //     />
            //   )
            // }
            value={searchTextTable}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
        </Col>
        <PartnerlistWithPayout
          landataSource={landatasource}
          makerAction={makerAction}
          checkerAction={checkerAction}
          utrAction={utrAction}
          makerPartnerAction={makerPartnerAction}
          setMakerAction={setMakerAction}
          setCheckerAction={setCheckerAction}
          setUtrAction={setUtrAction}
          setMakerPartnerAction={setMakerPartnerAction}
          setLanDatasource={setLanDatasource}
          handleRadioChange={handleRadioChange}
          radiostate={radiostate}
          pagination={pagination}
          onPageChange={handlePageChange}
          setRadioState={setRadioState}
          handleCheckboxChange={handleCheckboxChange}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          ReportId={monthlyReportId}
          currentStage={currentStage}
          fetchPaginatedData={fetchPaginatedData}
          fetchPayoutStagesData={fetchPayoutStagesData}
          downloading={downloading}
        />
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutApprovalStagesSuccess: (data) => dispatch(payoutApprovalStagesSuccess(data)),
    payoutPartnerDataSuccess: (data) => dispatch(payoutPartnerDataSuccess(data)),
    payoutPartnersearch: (data) => dispatch(payoutPartnerDataSearch(data)),
  }
};

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
    payoutApprovalStages: state.payoutApprovalStages.payoutApprovalStages,
    payoutPartnerData: state.payoutPartnerData.payoutPartnerData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerListDetails);
